import {inject, Injectable, InjectionToken} from '@angular/core';
import {collection, collectionSnapshots, Firestore, getFirestore, query} from "@angular/fire/firestore";
import {getApp} from "@angular/fire/app";
import {InHubMessage} from '../models/inHubMessage';
import {BehaviorSubject, firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Functions, getFunctions, httpsCallable} from "@angular/fire/functions";
import {environment, firebase} from "../../environments/environment.prod";

@Injectable({
  providedIn: 'root'
})
export class RepoHubService {

  inHubMessagesSubject: BehaviorSubject<InHubMessage[]> = new BehaviorSubject<InHubMessage[]>([]);
  targetLanguages: string[] = ['en', 'sv'];
  FIRESTORE_HUB = new InjectionToken<Firestore>('firestore other', {
    providedIn: 'root',
    factory: () => getFirestore(getApp('hub'))
  });
  FUNCTIONS_HUB = new InjectionToken<Functions>('functionsHub', {
    providedIn: 'root',
    factory: () => getFunctions(getApp(), 'europe-west3')
  });

  firestoreHub = inject(this.FIRESTORE_HUB);
  http = inject(HttpClient);
  private readonly firebaseFunctions = inject<Functions>(this.FUNCTIONS_HUB)
  private readonly apiKey = firebase.apiKey;
  private readonly baseUrl = 'https://translation.googleapis.com/language/translate/v2';

  constructor() {
    this.ListenToInAppMessages();
  }


  ListenToInAppMessages() {
    const inHubMessageCollection = query(collection(this.firestoreHub, 'inHubMessage'));

    collectionSnapshots(inHubMessageCollection).subscribe(res => {
      let data = res.map(value => {
        let message = value.data() as InHubMessage;
        message.created = new Date(value.data()["created"]);
        message.id = value.id;
        return message;
      })
      this.inHubMessagesSubject.next(data);
    })
  }


  async createInHubMessage(message: InHubMessage) {
    const updateInHubBanner = httpsCallable(this.firebaseFunctions, "updateInHubMessage", {})
    await updateInHubBanner(message);
  }

  async removeInHubMessage() {
    const removeInHubBanner = httpsCallable(this.firebaseFunctions, "deleteInHubMessage")
    await removeInHubBanner();
  }

  translateText(text: string): Promise<any[]> {
    const url = `${this.baseUrl}?key=${this.apiKey}`;

    let promises: Promise<any>[] = [];

    for (const targetLanguage of this.targetLanguages) {
      console.log(targetLanguage)
      const data = {
        q: text,
        target: targetLanguage
      };

      let p = firstValueFrom(this.http.post(url, data));
      promises.push(p)
    }

    return Promise.all(promises);
  }

}
